module.exports = __webpack_public_path__ + "static/media/ahmad-odeh-ckm1yAe6jhU-unsplash.a09933ae.jpg";